import { useCallback } from 'react';
import { useTheme } from 'emotion-theming';
import css from './cxs';
import { parseCssStyles } from './parse-styles';
export default function useCss() {
  var theme = useTheme();
  return useCallback(function (styles) {
    return css(parseCssStyles(styles, null, theme));
  }, [theme]);
}